import React from 'react';
import {Chip, Stack} from '@mui/material';
import {chartPhraseActions} from './EmptyState';

/**
 * Compact Chart phrase-chip row for the composer. Shown on a Chart after the
 * thread has exchanges (empty state already lists the same actions).
 */
const ChartPhraseChips = ({
    onAction,
    disabled = false,
    actions = chartPhraseActions(),
}) => {
    if (!Array.isArray(actions) || actions.length === 0) {
        return null;
    }

    return (
        <Stack
            data-testid="chart-phrase-chips"
            direction="row"
            spacing={0.5}
            flexWrap="wrap"
            useFlexGap
            sx={{px: 1.5, pt: 0.75, pb: 0.5}}
        >
            {actions.map((item) => (
                <Chip
                    key={item.label}
                    label={item.label}
                    size="small"
                    variant="outlined"
                    disabled={disabled}
                    onClick={() => onAction?.(item.action)}
                    aria-label={item.label}
                    sx={{height: 22, fontSize: 11}}
                />
            ))}
        </Stack>
    );
};

export default ChartPhraseChips;
